import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { SearchFilterOptionModel } from "apps-module/app/entry-modules/content-search/models/search-filter-option.model";
import { shortKey } from "apps-module/app/shared-library/utils/common.utils";

@Component({
    selector: "pcg-ng-checkbox",
    templateUrl: "./checkbox.component.html"
})
export class CheckboxComponent implements OnInit {
    public id: string = null;

    public control = new FormControl<boolean>(false);

    public model: SearchFilterOptionModel = null;
    @Input("value")
    public set valueSetter(value: SearchFilterOptionModel) {
        this.model = value || null;
        this.control.setValue(value?.selected || false);
    }

    @Output()
    public toggle = new EventEmitter();

    public onToggle(): void {
        this.model.selected = this.control.value;
        this.toggle.emit(this.model);
    }

    public ngOnInit(): void {
        this.id = shortKey();
    }
}
